<script setup>
import Popover from 'primevue/popover'
import { ref } from 'vue'

const op = ref(null)
const toggle = (event) => {
  op.value.toggle(event)
}
</script>

<template>
  <slot name="trigger" v-bind="{ toggle }">
    <button
      class="button is-small is-1by1"
      :class="[op?.visible ? 'is-light-100' : 'is-white']"
      @click="toggle"
    >
      <span class="icon">
        <iconify-icon icon="fluent:more-horizontal-20-filled" />
      </span>
    </button>
  </slot>

  <Popover ref="op" class="is-menu">
    <slot name="menu"></slot>
  </Popover>
</template>

<style scoped>
/* Add any additional styling here if needed */
</style>
